import { render, staticRenderFns } from "./EditarTipoMedidaModal.vue?vue&type=template&id=4385ed69&"
import script from "./EditarTipoMedidaModal.vue?vue&type=script&lang=ts&"
export * from "./EditarTipoMedidaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports